var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99.1635 99.3199L118.503 93.5099L121.163 91.5299C121.163 91.5299 121.343 91.3799 121.403 91.3599C121.653 91.2999 122.063 91.2299 122.373 91.4699C122.603 91.6499 122.663 91.9599 122.633 92.3199C122.623 92.4599 122.493 92.7999 122.193 93.3399C119.193 98.6499 100.443 121.55 70.1735 123.48C53.0735 124.57 34.7735 118.33 22.0135 105.21C9.90346 92.7499 2.36345 73.9299 5.31345 53.2299C9.72345 22.2899 28.5235 9.00991 34.7335 5.53991C35.8335 4.92991 36.5335 4.62991 36.7035 4.56991C38.8535 3.74991 39.9435 3.96991 40.1935 4.73991C40.2535 4.93991 40.1735 5.38991 39.8935 5.63991C38.7735 6.63991 38.0435 8.45991 38.0435 8.45991L27.6135 21.3399L22.7735 85.2299L72.1535 107.88L99.1635 99.3199Z",
    fill: "#FFB803"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3262 73.6504C50.2262 89.6204 67.0463 97.4204 82.6063 98.0404C105.396 98.9404 121.406 91.3604 121.406 91.3604C121.406 91.3604 109.906 105.37 93.3263 113.04C76.7463 120.71 49.4563 122.04 29.9263 105.26C8.47625 86.8104 7.20626 62.0804 11.2263 46.5304C19.5763 14.2604 40.0562 5.44043 40.0562 5.44043C40.0562 5.44043 30.1063 23.2204 31.1562 43.2104C31.9362 58.0904 35.4262 65.7504 40.3262 73.6504Z",
    fill: "#FFCA29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63 26L64.7961 31.5279H70.6085L65.9062 34.9443L67.7023 40.4721L63 37.0557L58.2977 40.4721L60.0938 34.9443L55.3915 31.5279H61.2039L63 26Z",
    fill: "#FFCA29"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88 64L89.3471 68.1459H93.7063L90.1796 70.7082L91.5267 74.8541L88 72.2918L84.4733 74.8541L85.8204 70.7082L82.2937 68.1459H86.6529L88 64Z",
    fill: "#FFCA29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/Moon.a74af618d7e32f72415df46517f14b02.svg";
export { ForwardRef as ReactComponent };